import { StockSymbol } from '@benzinga/session';
import { SessionContext } from '@benzinga/session-context';
import { TrackingManager } from '@benzinga/tracking-manager';
import React from 'react';

export const useTrackSymbol = (symbol: StockSymbol) => {
  const session = React.useContext(SessionContext);
  const trackingManager = session.getManager(TrackingManager);
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);
  const symbolRef = React.useRef<StockSymbol | null>(null);

  const onMouseEnter = React.useCallback(() => {
    if (timerRef.current || symbolRef.current === symbol) return;
    symbolRef.current = symbol;
    timerRef.current = setTimeout(() => {
      trackingManager.trackTickerEvent('hover', { symbol });
      symbolRef.current = symbol;
      timerRef.current = null;
    }, 3000);
  }, [symbol, trackingManager]);

  const onMouseLeave = React.useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    symbolRef.current = null;
  }, []);

  React.useEffect(() => {
    return () => {
      onMouseLeave();
      symbolRef.current = null;
    };
  }, [symbol, onMouseLeave]);

  return {
    onMouseEnter,
    onMouseLeave,
  };
};
